function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.5 20l4.86-9.73H13V4l-5 9.73h3.5V20M12 2c2.75 0 5.1 1 7.05 2.95C21 6.9 22 9.25 22 12s-1 5.1-2.95 7.05C17.1 21 14.75 22 12 22s-5.1-1-7.05-2.95C3 17.1 2 14.75 2 12s1-5.1 2.95-7.05C6.9 3 9.25 2 12 2z"
});

function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2 2 20 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZpZXdCb3g9IjIgMiAyMCAyMCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMTEuNSwyMEwxNi4zNiwxMC4yN0gxM1Y0TDgsMTMuNzNIMTEuNVYyME0xMiwyQzE0Ljc1LDIgMTcuMSwzIDE5LjA1LDQuOTVDMjEsNi45IDIyLDkuMjUgMjIsMTJDMjIsMTQuNzUgMjEsMTcuMSAxOS4wNSwxOS4wNUMxNy4xLDIxIDE0Ljc1LDIyIDEyLDIyQzkuMjUsMjIgNi45LDIxIDQuOTUsMTkuMDVDMywxNy4xIDIsMTQuNzUgMiwxMkMyLDkuMjUgMyw2LjkgNC45NSw0Ljk1QzYuOSwzIDkuMjUsMiAxMiwyWiIgLz48L3N2Zz4=";
export { SvgBolt as ReactComponent };